import { useNavigate, useSearch } from '@tanstack/react-router'

import type { LoginResponse } from '@/bindings/LoginResponse'
import type { System, UserOf } from '@/lib/auth-store'
import { afterLoginPath, loginPathFor } from '@/lib/return-path'
import { completeLogin } from '@/lib/session'

/** Store the login response, then leave for the return path (PRD login routing). */
export function useAfterLogin<S extends System>(system: S) {
  const navigate = useNavigate()
  const search = useSearch({ from: loginPathFor(system) })
  return (login: LoginResponse<UserOf<S>>) => {
    completeLogin(system, login)
    return navigate({ to: afterLoginPath(search, system), replace: true })
  }
}
